module.exports = __webpack_public_path__ + "static/media/google.ca2f7db2.png";